import { colorAccent, colorBlue } from '@spark/ui-components/theme/palette';
import { Row } from 'react-bootstrap';
import styled, { createGlobalStyle } from 'styled-components';

export const VehicleMapPopupStyles = createGlobalStyle`
  .leaflet-popup.vehicle-map-popup .leaflet-popup-close-button,
  .leaflet-popup.vehicle-map-popup a.leaflet-popup-close-button {
    top: 10px !important;
    right: 10px !important;
    width: 22px !important;
    height: 22px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 999px;
    border: 1px solid #b91c1c;
    background: #dc2626 !important;
    background-color: #dc2626 !important;
    background-image: none !important;
    color: #ffffff !important;
    font-size: 16px !important;
    font-weight: 700;
    line-height: 1 !important;
    text-align: center;
    text-decoration: none !important;
    text-shadow: none !important;
    box-shadow: 0 4px 10px rgba(220, 38, 38, 0.28);
  }

  .leaflet-popup.vehicle-map-popup .leaflet-popup-close-button:hover,
  .leaflet-popup.vehicle-map-popup a.leaflet-popup-close-button:hover {
    background: #b91c1c !important;
    background-color: #b91c1c !important;
    color: #ffffff !important;
  }
`;

export const TopActionsRow = styled(Row)``;

export const TopActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

export const PanelSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #edf1f7;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(34, 56, 101, 0.06);
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 8px 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #edf1f7;
`;

export const SectionTitle = styled.h3`
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #1c2f59;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.2;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    bottom: 2px;
    width: 4px;
    border-radius: 4px;
    background: ${colorAccent};
  }
`;

export const ClickableCardButton = styled.div`
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: transparent;
  text-align: left;
  color: inherit;
  cursor: ${props => (props.$disabled ? 'default' : 'pointer')};
`;

export const FrotaCardSurface = styled.div`
  overflow: hidden;
  container-type: inline-size;
  container-name: frota-card;
  border-radius: 10px;
  border: 1px solid ${props => (props.$selected ? '#9bd2a3' : '#d9e3f2')};
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  box-shadow: ${props => (props.$selected
    ? '0 10px 24px rgba(46, 175, 85, 0.14)'
    : '0 10px 24px rgba(26, 60, 117, 0.08)')};
  user-select: text;
`;

export const FrotaCardHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 56px 12px 14px;
  background: linear-gradient(135deg, #0e4a9c 0%, #12316f 68%, #0f2554 100%);
  color: #ffffff;

  @container frota-card (max-width: 380px) {
    flex-wrap: wrap;
    padding: 12px 14px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
  }
`;

export const FrotaCardHeaderMain = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1;

  @container frota-card (max-width: 380px) {
    flex: 1 1 160px;
  }
`;

export const FrotaCardIconShell = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.10) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
`;

export const FrotaCardTitleGroup = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const FrotaCardTitle = styled.div`
  font-size: ${props => props.$fontSize || 'clamp(16px, 1.8vw, 21px)'};
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FrotaCardSubtitle = styled.div`
  margin-top: 3px;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.92);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FrotaCardHeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.$justifyContent || 'flex-end'};
  gap: 8px;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;

  @container frota-card (max-width: 380px) {
    flex: 1 1 180px;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    justify-content: space-between;
  }
`;

export const FrotaHeaderActionStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${props => (props.$hasSecondaryAction ? 'center' : 'flex-start')};
  gap: ${props => (props.$hasSecondaryAction ? '8px' : '0')};
  min-width: 26px;
  position: absolute;
  right: 14px;
  top: ${props => (props.$hasSecondaryAction ? '50%' : '8px')};
  transform: ${props => (props.$hasSecondaryAction ? 'translateY(-50%)' : 'none')};

  @container frota-card (max-width: 380px) {
    position: static;
    margin-left: auto;
    transform: none;
  }

  @media (max-width: 768px) {
    position: static;
    transform: none;
    gap: 6px;
  }
`;

export const FrotaHeaderBadges = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.$justifyContent || 'flex-start'};
  flex-wrap: nowrap;
  gap: 6px;
  margin: 0 auto;
  min-width: ${props => props.$minWidth || 'auto'};

  @container frota-card (max-width: 380px) {
    flex: 1 1 auto;
    flex-wrap: wrap;
    margin: 0;
    min-width: 0;
    max-width: 100%;
  }
`;

export const FrotaHeaderBadgeItem = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
`;

export const FrotaHeaderBadgeLabel = styled.div`
  color: rgba(255, 255, 255, 0.82);
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`;

export const FrotaStatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 20px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  border: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.10);

  ${props => {
    switch (props.$tone) {
      case 'success':
        return `
          color: #e8fff5;
          background: #2f9f86;
          border-color: #3eaf95;
        `;
      case 'warning':
        return `
          color: #fff4dc;
          background: #b9822e;
          border-color: #cb9645;
        `;
      case 'danger':
        return `
          color: #fff0f0;
          background: #b85e5e;
          border-color: #c97575;
        `;
      case 'blue':
        return `
          color: #eef5ff;
          background: #4a78c9;
          border-color: #5b87d5;
        `;
      default:
        return `
          color: #f3f6fb;
          background: #6e7f99;
          border-color: #8191aa;
        `;
    }
  }}
`;

export const FrotaExpandButton = styled.button`
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border-radius: 999px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.10);
  }
`;

export const FrotaHeaderIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: ${props => {
    if (props.$status === 'found') return '#d4edda';
    if (props.$status === 'stale') return '#fff3cd';
    if (props.$status === 'missing') return '#f8d7da';
    return 'rgba(255, 255, 255, 0.08)';
  }};
  color: ${props => {
    if (props.$status === 'found') return '#155724';
    if (props.$status === 'stale') return '#856404';
    if (props.$status === 'missing') return '#721c24';
    return '#ffffff';
  }};
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: ${props => {
      if (props.$status === 'found') return '#c3e6cb';
      if (props.$status === 'stale') return '#ffeeba';
      if (props.$status === 'missing') return '#f5c6cb';
      return 'rgba(255, 255, 255, 0.14)';
    }};
  }
`;

export const FrotaCardBody = styled.div`
  padding: 0 8px 12px;

  @media (max-width: 768px) {
    padding: 0 6px 10px;
  }
`;

export const FrotaSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$gridTemplateColumns || 'repeat(3, minmax(0, 1fr))'};
  gap: 0;
  margin-top: -1px;
  border: 1px solid #d9e3f2;
  border-top: none;
  border-radius: 0;
  background: #ffffff;

  @container frota-card (max-width: 380px) {
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  }

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FrotaSummaryNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #d9e3f2;
  border-top: none;
  background: #f8fbff;
`;

export const FrotaSummaryNoticeText = styled.div`
  min-width: 0;
  flex: 1;
`;

export const FrotaSummaryNoticeLabel = styled.div`
  color: #4f6694;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
`;

export const FrotaSummaryNoticeValue = styled.div`
  margin-top: 4px;
  color: #10234f;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  word-break: break-word;
`;

export const FrotaSummaryItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  padding: 12px 14px;
  border-left: ${props => (props.$withDivider ? '1px solid #e5edf8' : 'none')};

  @container frota-card (max-width: 380px) {
    &:nth-child(2n + 1) {
      border-left: none;
    }
  }

  @media (max-width: 1100px) {
    &:nth-child(2n + 1) {
      border-left: none;
    }
  }

  @media (max-width: 640px) {
    border-left: none;
    border-top: 1px solid #e5edf8;

    &:first-child {
      border-top: none;
    }
  }
`;

export const FrotaSummaryText = styled.div`
  min-width: 0;
  flex: 1;
`;

export const FrotaSummaryLabel = styled.div`
  color: #4f6694;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
`;

export const FrotaSummaryValue = styled.div`
  margin-top: 5px;
  color: #10234f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  white-space: ${props => (props.$wrap ? 'normal' : 'nowrap')};
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: ${props => (props.$wrap ? 'anywhere' : 'normal')};
  word-break: ${props => (props.$wrap ? 'break-word' : 'normal')};
  display: ${props => (props.$wrap ? '-webkit-box' : 'block')};
  -webkit-box-orient: ${props => (props.$wrap ? 'vertical' : 'initial')};
  -webkit-line-clamp: ${props => (props.$wrap ? (props.$maxLines || 2) : 'unset')};
`;

export const FrotaSectionsWrap = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 12px;
`;

export const FrotaTripSection = styled.section`
  padding: 14px 12px;
  border-radius: 10px;
  border: 1px solid #d9e3f2;
  background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);

  @media (max-width: 768px) {
    padding: 12px 10px;
  }
`;

export const FrotaTripHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FrotaTripTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const FrotaTripTitle = styled.div`
  color: #132a5b;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.3;
  text-transform: uppercase;
`;

export const FrotaTripSubtitle = styled.div`
  margin-top: 3px;
  padding-left: 28px;
  color: #4f6694;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  text-transform: uppercase;
`;

export const FrotaTripBlockGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.$columns || 3}, minmax(0, 1fr));
  border: 1px solid #e0e9f6;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;

  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FrotaTripRouteGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #e0e9f6;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;

  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FrotaTripCell = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  padding: 12px 14px;
  border-left: ${props => (props.$withDivider ? '1px solid #e6eef8' : 'none')};

  @media (max-width: 960px) {
    border-left: none;
    border-top: 1px solid #e6eef8;

    &:first-child {
      border-top: none;
    }
  }
`;

export const FrotaTripCellText = styled.div`
  min-width: 0;
  flex: 1;
`;

export const FrotaTripCellLabel = styled.div`
  color: ${props => props.$accentColor || '#4f6694'};
  font-size: 10px;
  font-weight: 600;
  line-height: 1.2;
`;

export const FrotaTripCellValue = styled.div`
  margin-top: 4px;
  color: #10234f;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
`;

export const FrotaTripCellMeta = styled.div`
  margin-top: 3px;
  color: #47618d;
  font-size: 10px;
  line-height: 1.45;
`;

export const FrotaTripMetricsWrap = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 10px;
`;

export const FrotaFooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 12px;
  border: 1px solid #d9e3f2;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;

  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FrotaFooterItem = styled.div`
  min-width: 0;
  padding: 12px 14px;
  border-left: ${props => (props.$withDivider ? '1px solid #e6eef8' : 'none')};

  @media (max-width: 960px) {
    border-left: none;
    border-top: 1px solid #e6eef8;

    &:first-child {
      border-top: none;
    }
  }
`;

export const HistoryIndicatorWrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const HistoryActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const HistoryButton = styled.button`
  border: 1px solid #cfd8e3;
  background: #ffffff;
  color: #5c6b82;
  border-radius: 999px;
  width: 96px;
  height: 40px;
  display: grid;
  grid-template-columns: 18px 14px 40px;
  align-items: center;
  justify-content: center;
  column-gap: 6px;
  padding: 0 10px;
  cursor: pointer;
`;

export const HistoryRefreshButton = styled.button`
  border: 1px solid #cfd8e3;
  background: #ffffff;
  color: #2f5bea;
  border-radius: 999px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #eef3ff;
  }

  &:disabled {
    color: #93a1b4;
    cursor: not-allowed;
  }
`;

export const HistoryIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PauseIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  min-width: 14px;
  color: ${props => (props.$paused ? '#2eaf55' : '#d64545')};
`;

export const HistoryBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #2f5bea;
  width: 40px;
  text-align: left;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const HistoryTimestamp = styled.span`
  font-size: 9px;
  font-weight: 600;
  color: #7b8798;
  text-align: center;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

export const AvailabilityItemCard = styled.div`
  display: block;
  padding: 14px 16px;
  min-height: 84px;
  border-radius: 10px;
  background: ${props => (props.$selected ? '#e8f5e8' : `linear-gradient(90deg, ${colorBlue} 0%, ${colorAccent} 100%)`)};
  color: ${props => (props.$selected ? '#1f4f2a' : '#ffffff')};
  border: ${props => (props.$selected ? '1px solid #9bd2a3' : 'none')};
  user-select: text;
`;

export const AvailabilityCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const AvailabilityMainInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const AvailabilityTitle = styled.div`
  font-size: ${props => (props.$compact ? '12px' : '14px')};
  font-weight: 700;
  line-height: 1.2;
`;

export const AvailabilitySubtitle = styled.div`
  font-size: 11px;
  opacity: 0.9;
  margin-top: 2px;
`;

export const AvailabilityMetaGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin-top: 8px;
`;

export const AvailabilityExpandedSection = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`;

export const AvailabilityDetailSection = styled.div`
  & + & {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

export const AvailabilityDetailSectionTitle = styled.div`
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
`;

export const AvailabilityMetaLabel = styled.div`
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
`;

export const AvailabilityMetaSeparator = styled.span`
  opacity: 0.7;
  font-size: 9px;
  font-weight: 600;
`;

export const AvailabilityMetaValue = styled.div`
  display: inline;
  font-size: 11px;
  font-weight: 600;
  white-space: ${props => (props.$wrap ? 'normal' : 'nowrap')};
  overflow: ${props => (props.$wrap ? 'visible' : 'hidden')};
  text-overflow: ${props => (props.$wrap ? 'clip' : 'ellipsis')};
  overflow-wrap: ${props => (props.$wrap ? 'anywhere' : 'normal')};
  word-break: ${props => (props.$wrap ? 'break-word' : 'normal')};
`;

export const AvailabilityMetaItem = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  flex: ${props => (props.$fullWidth ? '1 1 100%' : '0 1 auto')};
`;

export const ExpandButton = styled.button`
  border: none;
  background: transparent;
  color: ${props => (props.$selected ? '#1f4f2a' : 'rgba(255, 255, 255, 0.85)')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const ButtonIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  vertical-align: middle;
`;
